exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-rank[data-v-1774538e]{width:100%}.yxtbiz-rank .yxtbiz-rank__empty[data-v-1774538e]{display:flex;justify-content:center;align-items:center}\n", ""]);

